<template>
    <div class="box is-success">
        <h3 class="title">{{ toTitleCase(localId) }} Searches</h3>
        <div class="field">
            <b-switch
              v-model="value.isSuccess"
              :type="value.isSuccess ? 'is-success' : 'is-danger'"
            >
              Satisfactory: <strong>{{ value.isSuccess ? 'Yes' : 'No' }}</strong>
            </b-switch>
        </div>
        <b-field label="Summary on search">
            <b-input type="textarea"
              v-model="localSummary"
            />
        </b-field>

        <div class="buttons has-addons is-right">
            <button
              class="button is-primary is-outlined"
              :disabled="editNotAllowed"
              @click="updateForm"
              >Save</button>
        </div>

        <b-field class="file">
            <b-upload
              v-model="filesToUpload"
              :multiple="true"
              :disabled="editNotAllowed"
              @input="uploadFiles"
            >
                <a class="button is-primary" :disabled="editNotAllowed">
                    <b-icon icon="upload"/>
                    <span>Click to upload search results</span>
                </a>
            </b-upload>
            <span class="file-name"
                v-if="filesToUpload && filesToUpload.length"
                v-for="file in filesToUpload"
                :key="file.name"
            >
                {{ file.name }}
            </span>
        </b-field>

        <div class="files-list" v-if="value.files">
            <p class="subtitle">Uploaded search results ({{ value.files.length }})</p>
            <b-table
              :data="value.files"
              narrowed
              default-sort="['uploaded_date', 'desc']"
            >
                <template slot-scope="props">
                    <b-table-column label="File" field="name" sortable>
                        <a href=""
                          @click.prevent="getLink(props.row.id)">
                            {{ props.row.name }}
                        </a>
                    </b-table-column>
                    <b-table-column label="Uploaded" field="uploaded_date" sortable>
                        {{ formatDate(props.row.uploaded_date) }}
                    </b-table-column>
                    <b-table-column label="Uploaded by" field="uploaded_by" sortable>
                        {{ props.row.uploaded_by }}
                    </b-table-column>
                    <b-table-column label="Actions" v-if="$auth.check(['admin', 'superadmin'])">
                      <a href="" @click.prevent="deleteSearchFile(props.row.id)">
                        <b-icon icon="delete"/>
                      </a>
                    </b-table-column>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import changeCase from 'change-case'

export default {
  name: 'KycSearchResults',
  props: ['kycId', 'id', 'value', 'editNotAllowed'],
  data () {
    return {
      localId: this.id,
      filesToUpload: [],
      localSummary: this.value.summary
    }
  },
  watch: {
    id () {
      this.localId = this.id
    },
    value () {
      this.localSummary = this.value.summary
    }
  },
  methods: {
    uploadFiles () {
      this.filesToUpload.forEach(file => {
        const reader = new FileReader()
        reader.onload = () => {
          this.uploadFile(file.name, file.type, reader.result)
        }
        reader.readAsDataURL(file)
      })
    },
    uploadFile (fileName, fileType, content) {
      this.axios.post(`/kyc/${this.kycId}/checks/upload`, {
        check_id: this.localId,
        file_name: fileName,
        file_type: fileType,
        content,
        uploaded_date: Date.now()
      })
        .then(response => {
          this.value.files = response.data.files
          this.$toast.open({
            'message': 'File upload successful',
            'type': 'is-success'
          })
          this.filesToUpload = []
        })
        .catch(error => {
          console.log(error)
          this.$toast.open({
            'message': error.message,
            'type': 'is-danger'
          })
        })
    },
    getLink (fileId) {
      window.location.replace(
        `${this.axios.defaults.baseURL}/kyc/${this.kycId}/file/${fileId}`
      )
    },
    updateForm () {
      this.$set(this.value, 'summary', this.localSummary)
      this.$emit('input', this.value)
    },
    toTitleCase (str) {
      return changeCase.title(str)
    },
    formatDate (date) {
      if (!date) return ''
      return moment(date).format()
    },
    deleteSearchFile (fileId) {
      const fileIdx = this.value.files.findIndex(f => f.id === fileId)
      if (fileIdx === null) return
      this.value.files.splice(fileIdx, 1)
      this.$emit('input', this.value)
    }
  }
}
</script>
